// extracted by mini-css-extract-plugin
export var loadingSpinner = "_4f-1";
export var standaloneTable = "_4f-0";